import React, { useRef } from 'react'
import ThisProject from '../ThisProject';
import MotionContent from '../../components/containers/MotionContent';
import { ImageMedia,/*  Section,  */TextBox } from '../../components/imports';
// import useDisplayValue from '../../hooks/useDisplayValue';
// import useMouse from '../../hooks/useMouse';

const Content = () => {

  // const heroRef = useRef(null);
  const laptopRef = useRef(null);

  // const { formattingFn } = useDisplayValue("");
  // const { toDefault, toPlay } = useMouse();

  return (
    <ThisProject>
      {({ thisProject, projectId, prLink }) => (
        <div className='projectContent'>

          <ImageMedia
            key={"AnnagramWeb"}
            src={require('./assets/_cover.jpg')}
            className="full"
          />
          <div className='flex flex-col relative items-center justify-center w-full space-y-6 mb-24 -mt-[5%]'>
            <div className='grid grid-cols-3 resp gap-4 max-h-100 *:h-full '>
              <ImageMedia src={require('./assets/ig_profilePic_1.jpg')} />
              <ImageMedia src={require('./assets/ig_profilePic_2.jpg')} />
              <ImageMedia src={require('./assets/ig_profilePic_3.jpg')} />
            </div>
            <TextBox
              title={"Logo Concept"}
              descr={"Abstract symbol, the main logo of Annagram is made of a [A] and a [G] vertically stacked. This lockup expresses Precision, Technology Growth and Connectors path in the negative spaces."}
              className={"resp paddingY"}
            />
            <ImageMedia src={require('./assets/icon.png')} className={" paddingX !object-contain !max-h-100 "} />
          </div>

          <ImageMedia
            key={"Annagradoc"}
            src={require('./assets/annagram_doc.jpg')}
            className="full max-lg:portrait:min-h-[600px]"
          />

          {/* WEB PREVIEW */}
          <TextBox
              title={"Web design"}
              descr={"[AG] website was entrusted to us to conceptualise, design and develop. No templates, no copy/paste. A clean interface following coherently its visual identity."}
              className={"resp paddingY"}
            />

          <MotionContent imgRef={laptopRef} height={"height"} className="flex flex-col" refDiv={require('./assets/annagram_web.jpg')}>
            <ImageMedia
              key={"AnnagramWeb"}
              src={require('./assets/annagram_web.jpg')}
              className="full max-lg:portrait:min-h-[600px]"
            />
            {/* DESK ONLY */}
            <div className='DESK flex-col resp= items-start justify-start absolute bg-transparent! inset-x-0 z-10 bottom-10 left-10'>

              <div className='flex flex-col h-fit w-fit items-center justify-center mr-auto' key={"SeeWeb"}>
                <ImageMedia
                  key={"Annagradoc"}
                  src={require('./QR_Vercel_Anngram_ byLAWWD.png')}
                  className="size-40 self-center"
                />
                <h5 className='text-xs padding unmute! text-white p-2 rounded animate-pulse= whitespace-nowrap w-full text-center mix-blend-exclusion'>Scan to view <i className='ri-arrow-right-up-line' /></h5>
              </div>
            </div>
          </MotionContent>

          {/* MOB ONLY */}
          <div className='MOB flex-col padding mt-20  items-center justify-center' key={"SeeWeb"}>
            <ImageMedia
              key={"Annagradoc"}
              src={require('./QR_Vercel_Anngram_ byLAWWD.png')}
              className="size-40 self-center"
            />
            <h5 className='text-xs padding unmute! text-white p-2 rounded animate-pulse whitespace-nowrap w-full text-center mix-blend-exclusion'>Scan to view <i className='ri-arrow-right-up-line' /></h5>
          </div>


          {/* <div className='grid grid-cols-1 lg:grid-cols-2 w-full bg-black pt-12'>
            <MotionContent imgRef={heroRef} height={"lg:h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img" + thisProject.client}
                src={require('./assets/AnimaIris, 14.jpg')}
                className="relative md:landscape:scale-[110%] full object-contain object-center"
              />
            </MotionContent>
            <MotionContent imgRef={heroRef} height={"h-[100vh]"} translateRange={["10%", "20%"]} className="">
              <ImageMedia
                key={"img2" + thisProject.client}
                src={require('./assets/_cover.jpg')}
                className="relative md:landscape:scale-[110%] full object-cover lg:object-contain object-center"
              />
            </MotionContent>
          </div> */}
        </div>
      )}
    </ThisProject>
  )
}

export default Content